<template>
    <div class="animated fadeIn master-detail-page">
        <!-- Back Button -->
        <div class="mb-3">
            <button type="button" class="btn btn-back" @click="pindahKeTransaksiPby">
                <i class="fa fa-chevron-left mr-1"></i> Back
            </button>
        </div>

        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />

        <div v-else class="master-form-card">
            <h4 class="form-page-title mb-4">Detail Transaksi Pembayaran</h4>

            <!-- Alert Khusus Rollover -->
            <b-alert variant="warning" show v-if="dataDetailPembayaran.isRollover || (dataDetailPembayaran.counterPerpanjangan && dataDetailPembayaran.counterPerpanjangan >= 4)" class="mb-4">
                <div class="d-flex align-items-start">
                    <i class="fa fa-sync-alt mt-1 mr-2 text-warning" style="font-size: 18px;"></i>
                    <div>
                        <strong>Transaksi Rollover (Perpanjangan ke-4)</strong>
                        <p class="mb-0 small text-dark">
                            Pencetakan bukti pembayaran ini akan menutup faktur <strong>{{ dataDetailPembayaran.noFaktur }}</strong> dan otomatis menerbitkan Nomor Surat Bukti Gadai (SBG) Baru.
                        </p>
                    </div>
                </div>
            </b-alert>

            <!-- DATA TRANSAKSI -->
            <div class="form-section-block">
                <div class="form-section-header">
                    <span class="section-accent-bar"></span>
                    <span class="section-label">DATA TRANSAKSI</span>
                </div>
                <b-row class="detail-info-row">
                    <b-col cols="4" md="3" class="detail-label">No. Transaksi</b-col>
                    <b-col class="detail-value">{{ dataDetailPembayaran.noKwitansi || dataDetailPembayaran.noTransaksi || '-' }}</b-col>
                </b-row>
                <b-row class="detail-info-row">
                    <b-col cols="4" md="3" class="detail-label">No. Faktur</b-col>
                    <b-col class="detail-value">
                        <span>{{ dataDetailPembayaran.noFaktur || '-' }}</span>
                        <b-badge variant="info" class="ml-2" v-if="dataDetailPembayaran.counterPerpanjangan && dataDetailPembayaran.counterPerpanjangan > 0">
                            Perpanjangan ke-{{ dataDetailPembayaran.counterPerpanjangan }}
                        </b-badge>
                    </b-col>
                </b-row>
                <b-row class="detail-info-row" v-if="dataDetailPembayaran.parentNoFaktur">
                    <b-col cols="4" md="3" class="detail-label">Rollover Dari</b-col>
                    <b-col class="detail-value">
                        <b-badge variant="secondary" style="font-size: 12px;">
                            <i class="fa fa-link mr-1"></i> {{ dataDetailPembayaran.parentNoFaktur }}
                        </b-badge>
                    </b-col>
                </b-row>
                <b-row class="detail-info-row">
                    <b-col cols="4" md="3" class="detail-label">Jenis</b-col>
                    <b-col class="detail-value">{{ getJenisPembayaran }}</b-col>
                </b-row>
                <b-row class="detail-info-row">
                    <b-col cols="4" md="3" class="detail-label">Cabang</b-col>
                    <b-col class="detail-value">{{ getCabangName }}</b-col>
                </b-row>
                <b-row class="detail-info-row">
                    <b-col cols="4" md="3" class="detail-label">Tanggal</b-col>
                    <b-col class="detail-value">{{ getFormattedTanggal }}</b-col>
                </b-row>
                <b-row class="detail-info-row">
                    <b-col cols="4" md="3" class="detail-label">Kasir</b-col>
                    <b-col class="detail-value">{{ getKasirName }}</b-col>
                </b-row>
            </div>

            <!-- RINCIAN PEMBAYARAN -->
            <div class="form-section-block">
                <div class="form-section-header">
                    <span class="section-accent-bar"></span>
                    <span class="section-label">RINCIAN PEMBAYARAN</span>
                </div>
                <b-row class="detail-info-row" v-for="(item, idx) in dataDetailPembayaran.detail" :key="idx">
                    <b-col cols="4" md="3" class="detail-label">{{ item.name }}</b-col>
                    <b-col class="detail-value">{{ item.nominal == null ? '-' : 'Rp. ' + $helper.addThousandSeparator(item.nominal) }}</b-col>
                </b-row>
                <b-row class="detail-info-row" v-if="dataDetailPembayaran.angsuranPokok != null && dataDetailPembayaran.angsuranPokok > 0">
                    <b-col cols="4" md="3" class="detail-label">Angsuran Pokok</b-col>
                    <b-col class="detail-value">Rp. {{ $helper.addThousandSeparator(dataDetailPembayaran.angsuranPokok) }}</b-col>
                </b-row>
                <b-row class="detail-info-row">
                    <b-col cols="4" md="3" class="detail-label">Total Dibayar</b-col>
                    <b-col class="detail-value">
                        <span v-if="dataDetailPembayaran.nominalPembayaran != null">Rp. {{ $helper.addThousandSeparator(dataDetailPembayaran.nominalPembayaran) }}</span>
                        <span v-else>-</span>
                    </b-col>
                </b-row>
                <b-row class="detail-info-row">
                    <b-col cols="4" md="3" class="detail-label">Metode</b-col>
                    <b-col class="detail-value">{{ getMetodePembayaran }}</b-col>
                </b-row>
            </div>

            <!-- STATUS -->
            <div class="form-section-block">
                <div class="form-section-header">
                    <span class="section-accent-bar"></span>
                    <span class="section-label">STATUS</span>
                </div>
                <b-row class="detail-info-row">
                    <b-col cols="4" md="3" class="detail-label">Status Transaksi</b-col>
                    <b-col class="detail-value">{{ getStatusTransaksi }}</b-col>
                </b-row>
                <b-row class="detail-info-row">
                    <b-col cols="4" md="3" class="detail-label">Void</b-col>
                    <b-col class="detail-value">{{ (dataDetailPembayaran.status == 'Void' || dataDetailPembayaran.isVoid == true) ? 'Ya' : 'Tidak' }}</b-col>
                </b-row>
                <b-row class="detail-info-row">
                    <b-col cols="4" md="3" class="detail-label">Jatuh Tempo Baru</b-col>
                    <b-col class="detail-value">{{ getJatuhTempoBaru }}</b-col>
                </b-row>
            </div>

            <!-- Action Buttons -->
            <div class="detail-actions-footer">
                <button 
                    type="button" 
                    class="btn btn-outline-action" 
                    name="cetakBtn" 
                    @click="confirmCetakKwitansi"
                >
                    Cetak Bukti
                </button>
                <button 
                    v-if="dataDetailPembayaran.status != 'Request Void' && dataDetailPembayaran.status != 'Void'" 
                    type="button" 
                    class="btn btn-outline-danger-action" 
                    name="voidBtn" 
                    @click="confirmVoidPembayaran"
                >
                    Ajukan Void
                </button>
            </div>
        </div>

        <ModalConfirm id="modal-confirm-cetak" title="Confirm Cetak Kwitansi" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mencetak Kwitansi ini?" @submit="onSubmit" />
    
        <b-modal id="modal-confirm-void" title="Confirm Void Pembayaran" no-close-on-backdrop centered>
            <b-form id="voidPembayaranForm" @submit.prevent="onVoid">
                <div class="form-content-wrapper mb-0">
                    <b-form-group label="Keterangan/ Alasan Void" class="mb-0">
                        <b-form-textarea
                            v-model="input.keteranganVoid" 
                            name="keteranganVoid"
                            rows="3"
                            max-rows="6"
                            required
                        ></b-form-textarea>
                    </b-form-group>
                </div>
                <b-alert variant="primary" class="mt-3 mb-0" :show="dataDetailPembayaran.status == 'Confirmed'">* Pengajuan void ini akan melewati approval dari KCS sebelum disahkan</b-alert>
            </b-form>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="cancelVoidBtn" @click="cancel()" :disabled="isSubmitting">
                    Cancel
                </b-button>
                <b-button type="submit" name="voidSubmitBtn" variant="danger" :disabled="isSubmitting" form="voidPembayaranForm">
                    {{ isSubmitting ? "Sedang mengirim..." : "Kirim" }}
                </b-button>
            </template>
        </b-modal>

        <b-modal title="Print Kwitansi Pembayaran" ok-only no-close-on-esc no-close-on-backdrop size="xl" id="modal-print" @hide="pindahKeTransaksiPby">
            <p class="smallText text-muted">
                Bila tombol print / cetak tidak ditemukan, anda dapat melakukan pencetakan dengan cara klik kanan pada lembar yang akan dicetak, lalu pilih Print.
            </p>
            <b-row class="mb-2">
                <b-col class="detail-data-label">Kwitansi</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col><iframe width="100%" height="300" :src="urlKwitansi" frameborder="0" allowfullscreen></iframe></b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'detail-transaksi-pembayaran',
    data(){
        return{
            id: null,
            initStatus: 0,
            dataDetailPembayaran: {},
            isSubmitting: false,
            urlKwitansi: null,
            input:{
                keteranganVoid: ""
            }
        }
    }, 
    computed: {
        getJenisPembayaran() {
            if (!this.dataDetailPembayaran || !this.dataDetailPembayaran.jenis) return '-'
            if (this.dataDetailPembayaran.jenis === 'Perpanjangan + Cicilan Pokok') return 'Perpanjangan'
            return this.dataDetailPembayaran.jenis
        },
        getCabangName() {
            if (!this.dataDetailPembayaran) return '-'
            if (this.dataDetailPembayaran.cabang && this.dataDetailPembayaran.cabang.name) {
                return this.dataDetailPembayaran.cabang.name
            }
            if (this.dataDetailPembayaran.cabangPenggadaian && this.dataDetailPembayaran.cabangPenggadaian.name) {
                return this.dataDetailPembayaran.cabangPenggadaian.name
            }
            if (typeof this.dataDetailPembayaran.cabang === 'string') {
                return this.dataDetailPembayaran.cabang
            }
            if (this.dataDetailPembayaran.namaCabang) {
                return this.dataDetailPembayaran.namaCabang
            }
            return '-'
        },
        getFormattedTanggal() {
            if (!this.dataDetailPembayaran) return '-'
            const dateVal = this.dataDetailPembayaran.tanggalPembayaran || this.dataDetailPembayaran.createdDate || this.dataDetailPembayaran.tanggalTransaksi || this.dataDetailPembayaran.createdAt
            if (!dateVal) return '-'
            const date = this.$helper.changeDateFormat(dateVal)
            const hour = this.$helper.changeDateFormatGetHour(dateVal)
            return hour ? `${date} - ${hour}` : date
        },
        getKasirName() {
            if (!this.dataDetailPembayaran) return '-'
            if (this.dataDetailPembayaran.kasir && this.dataDetailPembayaran.kasir.name) {
                return this.dataDetailPembayaran.kasir.name
            }
            if (this.dataDetailPembayaran.creator && this.dataDetailPembayaran.creator.name) {
                return this.dataDetailPembayaran.creator.name
            }
            if (this.dataDetailPembayaran.kasirName) return this.dataDetailPembayaran.kasirName
            if (this.dataDetailPembayaran.userName) return this.dataDetailPembayaran.userName
            if (typeof this.dataDetailPembayaran.kasir === 'string') return this.dataDetailPembayaran.kasir
            if (typeof this.dataDetailPembayaran.creator === 'string') return this.dataDetailPembayaran.creator
            return '-'
        },
        getMetodePembayaran() {
            if (!this.dataDetailPembayaran) return '-'
            if (this.dataDetailPembayaran.metodePembayaran) return this.dataDetailPembayaran.metodePembayaran
            if (this.dataDetailPembayaran.isTunai !== undefined && this.dataDetailPembayaran.isTunai !== null) {
                return this.dataDetailPembayaran.isTunai ? 'Tunai' : 'Transfer'
            }
            if (this.dataDetailPembayaran.pembayaranTunai !== undefined && this.dataDetailPembayaran.pembayaranTunai !== null) {
                return this.dataDetailPembayaran.pembayaranTunai ? 'Tunai' : 'Transfer'
            }
            return 'Tunai'
        },
        getStatusTransaksi() {
            if (!this.dataDetailPembayaran) return '-'
            if (this.dataDetailPembayaran.statusPembayaran) {
                return this.dataDetailPembayaran.statusPembayaran.toUpperCase()
            }
            if (this.dataDetailPembayaran.status) {
                if (typeof this.dataDetailPembayaran.status === 'string') {
                    return this.dataDetailPembayaran.status.toUpperCase()
                }
                if (this.dataDetailPembayaran.status.name) {
                    return this.dataDetailPembayaran.status.name.toUpperCase()
                }
            }
            return '-'
        },
        getJatuhTempoBaru() {
            if (!this.dataDetailPembayaran) return '-'
            const jt = this.dataDetailPembayaran.jatuhTempoBaru || this.dataDetailPembayaran.tanggalJatuhTempoBaru || this.dataDetailPembayaran.jatuhTempoSelanjutnya || this.dataDetailPembayaran.jatuhTempo || this.dataDetailPembayaran.tanggalJatuhTempo
            if (!jt) return '-'
            return this.$helper.changeDateFormat(jt)
        }
    },
    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id

            let getSingleGadai = this.$axios.get(`gadai-pembayaran/${this.id}`).then(response => {
                this.dataDetailPembayaran = response.data
                console.log(response.data)
                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getSingleGadai]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        //----------------- Submit Request Cetak Kwitansi -----------------

        onSubmit(){
            this.isSubmitting = true

            let payload = new FormData()
            payload.append("pembayaranId", this.id)

            this.$axios.post("gadai-pembayaran/cetak-kwitansi", payload).then(response => {
                this.$helper.setFlash(`Request Cetak Kwitansi berhasil dilakukan!`)
                this.$bvModal.hide("modal-confirm-cetak")
                
                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)

                this.urlKwitansi = this.$baseFilePath+response.data.name
                this.$bvModal.show("modal-print")

                if (this.dataDetailPembayaran.counterPrint != null) {
                    this.dataDetailPembayaran.counterPrint++
                }
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        //----------------- Submit Request Void -----------------
        
        onVoid(){
            this.isSubmitting = true

            let payload = new FormData()
            payload.append("pembayaranId", this.id)
            payload.append("keterangan", this.input.keteranganVoid)

            this.$axios.post("gadai-pembayaran/request-void", payload).then(response => {
                this.$helper.setFlash(`Void Pembayaran berhasil dilakukan!`)
                this.$bvModal.hide("modal-confirm-void")
                
                let path = this.$route.path.split("/")
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },


        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        confirmCetakKwitansi(){
            this.$bvModal.show("modal-confirm-cetak")
        },

        confirmVoidPembayaran(){
            this.$bvModal.show("modal-confirm-void")
        },

        pindahKeTransaksiPby(){
            let path = this.$route.path.split('/')
            path.pop()
            path = path.join("/")
            this.$router.push({ path })
        }
        
    },

    created(){
        this.init()
    }
}
</script>

<style lang="scss" scoped>
.master-detail-page {
    padding-bottom: 30px;
}
</style>
